module.exports = __webpack_public_path__ + "8d38b67305ddf6b35678fc1ca59e9eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/lawbreakers/vertigo.png
// module id = 1077
// module chunks = 0